module.exports = __webpack_public_path__ + "img/14_11.3596517b.png";